import React from "react";
import classnames from "classnames";
import { Helmet } from "react-helmet-async";
import RuneOverview from "./RuneOverview";
import StatShardOverview from "./StatShardOverview";
import { getPercetange, numberWithCommas } from "lib/general-helper";
import { getRoleLabel } from "lib/role_helper";
import { validParams } from "query_parameters/valid_parameters";
import runeTipsData from "./rune-tips.js";
import { useJSONFetcher } from "@outplayed/json-fetcher";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const RuneTips = (props) => {
  const { getChampionName, getChampionImg, useRiotRunes } = getRiotAssetsContext();
  const { championId, oppChampionId, runes, statShards, role, rank } = props;

  const envDir = process.env.RIOT_PATCH_ASSETS === "staging" ? "staging" : "prod";
  const { data: seoNames, loading: loadingSEONames } = useJSONFetcher(
    `https://static.bigbrain.gg/assets/lol/riot_patch_update/${envDir}/seo-champion-names.json`,
    { ssr: true },
  );
  const { data: riotRunes, loading: loadingRunes } = useRiotRunes({ ssr: true });
  const championName = getChampionName(championId);
  const oppChampionName = getChampionName(oppChampionId) || "All Champions";
  const validPageParams = validParams["runes"] || {};
  const rankOptions = validPageParams.rank || [];
  const currentRank = rankOptions.find((rankOption) => rankOption.value === rank);
  const rankLabel = (currentRank && currentRank.label) || "";

  if (loadingSEONames || loadingRunes) {
    return null;
  }

  const allKeystones = riotRunes.reduce((acc, curr) => {
    const keystones = curr.slots[0].runes;
    const keystoneIDs = keystones.map((el) => el.id);
    return [...acc, ...keystoneIDs];
  }, []);

  const getRunePageScore = () => {
    let score = 0;
    if (runes.active_perks && statShards.activeShards) {
      for (const runeId of runes.active_perks) {
        score += (runeTipsData["runes"][runeId] && runeTipsData["runes"][runeId]["score"]) || 0;
      }
      statShards.activeShards.forEach((shardId, index) => {
        const rolePosition = role === "jungle" ? "jungle" : "lane";
        const data = runeTipsData["statShards"][index][shardId][rolePosition];
        score += (data && data["score"]) || 0;
      });
    }
    return score;
  };

  const runeOverviewProps = {
    allKeystones,
    riotRunes,
    seoNames: seoNames[championId],
    championId,
    oppChampionId,
    role,
    activePerks: runes.active_perks,
  };

  const runePageScore = getRunePageScore();

  return (
    <div className="rune-tips_content">
      <Helmet>
        <meta name="runepagescore" content={runePageScore} />
      </Helmet>
      <div className="overview-header">
        At <strong>{getPercetange(runes.wins, runes.matches, 2)}%</strong> winrate over{" "}
        <span>{numberWithCommas(runes.matches)}</span> matches, this specific {getRoleLabel(role)} {championName} rune page has
        worked the best for most players in {rankLabel} vs{" "}
        <div className={`text-sub text-sub_opp-champion${props.oppChampionId ? "_with-image" : ""}`}>
          {props.oppChampionId > 0 && <img src={getChampionImg(props.oppChampionId)} />}
          <span>{oppChampionName}</span>
        </div>
        .
      </div>
      <RuneOverview {...runeOverviewProps} perkStyle={runes.primary_style} isPrimary />
      <RuneOverview {...runeOverviewProps} perkStyle={runes.sub_style} />
      <StatShardOverview
        seoNames={seoNames[championId]}
        championId={championId}
        oppChampionId={oppChampionId}
        role={role}
        activeShards={statShards.activeShards}
      />
    </div>
  );
};

export default RuneTips;
